module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/logo_serasa_credito_rosa-07af898da58fc4ad1301bbe65869693e.png";